import React from "react";

import PageWrapper from "../components/PageWrapper";
import Examples from "../sections/landing4/Examples";
import CTA from "../sections/landing4/CTA";

const ExamplesPage = () => {
  return (
    <>
      <PageWrapper>
        <Examples />
        <CTA />
      </PageWrapper>
    </>
  );
};
export default ExamplesPage;
